import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../services/app-services/auth-service";

const initialState: any = {
  isLoading: false,
  isSuccess: false,
  loading: false,
  isError: false,
  message: "",
  user: {},
};

export const loginWithToken = createAsyncThunk<any, any>("user/token", async (_, thunkAPI) => {
  try {
    return await authService.loginWithToken();
  } catch (error: any) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

// ...action.payload?.data?.user,
export const userAuthReducer = createSlice({
  name: "user",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.user = {};
    },
    updateUser: (state, action) => {
      state.user = {
        ...state.user, // Keep the existing user details
        ...action.payload, // Merge with the updated user details
      };
      state.message = "User details updated successfully!";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginWithToken.pending, (state) => {
        state.loading = true;
        state.user = {};
      })
      .addCase(loginWithToken.fulfilled, (state, action) => {
        state.loading = false;
        state.isSuccess = action.payload.success;
        state.user = {
          ...action.payload?.data?.user,
          auth_token: action?.payload?.config?.headers?.session_id,
        };
      })
      .addCase(loginWithToken.rejected, (state: any, action) => {
        state.message = action.payload;
        state.loading = false;
        state.isError = true;
      });
  },
});

export const { reset, updateUser } = userAuthReducer.actions;

export default userAuthReducer.reducer;
